import { useState } from "react";
import { createSelectorConfirm } from "../../../../utils/createSelectorConfirm";

// trado has TWO trailers: one for berangkat (data_trailer_berangkat) and one for pulang (data_trailer_pulang)
const useTradoEditorTrailerDialogs = ({ headerData, setHeaderData }) => {
  const [showTrailerBerangkatSelector, setShowTrailerBerangkatSelector] =
    useState(false);
  const [showTrailerPulangSelector, setShowTrailerPulangSelector] =
    useState(false);

  const handleOnClickTrailerBerangkat = () => {
    setShowTrailerBerangkatSelector(true);
  };

  const handleOnClickTrailerPulang = () => {
    setShowTrailerPulangSelector(true);
  };

  const handleOnConfirmTrailerBerangkat = createSelectorConfirm({
    headerData,
    setHeaderData,
    dataField: "data_trailer_berangkat",
    idField: "trailer_berangkat_id",
    setShow: setShowTrailerBerangkatSelector,
  });

  const handleOnConfirmTrailerPulang = createSelectorConfirm({
    headerData,
    setHeaderData,
    dataField: "data_trailer_pulang",
    idField: "trailer_pulang_id",
    setShow: setShowTrailerPulangSelector,
  });

  return {
    showTrailerBerangkatSelector,
    setShowTrailerBerangkatSelector,
    showTrailerPulangSelector,
    setShowTrailerPulangSelector,
    handleOnClickTrailerBerangkat,
    handleOnClickTrailerPulang,
    handleOnConfirmTrailerBerangkat,
    handleOnConfirmTrailerPulang,
  };
};

export default useTradoEditorTrailerDialogs;
